import { createSlice } from '@reduxjs/toolkit';

type SignInReducerType = {
  user: {
    phone_number?: string;
    extension?: string;
    dial_code?: string; // <-- Add this line
    [key: string]: any;
  };
};

const initialState: SignInReducerType = {
  user: {
    phone_number: '',
    extension: '',
    dial_code: '',
    // ...other fields
  },
};

export const SignInSlice = createSlice({
  name: 'Sign In',
  initialState,
  reducers: {
    updateUserData: (state, action) => {
      const data = action?.payload?.data ?? {};
      state.user = {
        ...state.user,
        ...data,
        dial_code: data.dial_code ?? state.user.dial_code,
      };
    },
  },
});

export const { updateUserData } = SignInSlice.actions;
export default SignInSlice.reducer;
